module.exports = __webpack_public_path__ + "static/img/mogu.605f03a1.jpg";